var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardStatCard',{attrs:{"title":"Outstanding","subtitle":"Customer balance","icon":"mdi-cash-clock","color":"orange","loading":_vm.isLoading,"to":"/customer/list"}},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.amount))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }